import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { gridSpacing } from 'store/constant';
import { styled, useTheme } from '@mui/material/styles';
import { connect, useDispatch } from 'react-redux';

import {
  Avatar,
  Button,
  CardActions,
  CardContent,
  Divider,
  Grid,
  Menu,
  MenuItem,
  Typography,
  Toolbar,
  CssBaseline,
  AppBar,
  Input,
  Select,
  TextField,
  Autocomplete,
  Checkbox,
  Box,
  FormGroup,
  label,
  Chip
} from '@mui/material';

import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { startOfYesterday, format, addDays } from 'date-fns';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import Switch from '@mui/material/Switch';
import CloseIcon from '@mui/icons-material/Close';

import './styleSearch.scss';
import { maxWidth } from '@mui/system';
import AdvertisersFilter from './AdvertisersFilter';
import WowQuarterDropDown from './WowQuarterDropDown';
import DateSelectorV1 from './DateSelectorV1';
import {
  fetchAdvertiserList,
  setSelectedAdvertiser,
  fetchCampaignsByAdvertiserGuid,
  fetchCampaignsForAdvertiser,
  fetchSkanCampaignsForAdvertiser,
  fetchCampaignsForQuarters
} from '../../redux/advertiser/advertiserActions';
import { resetScreenData } from '../../redux/campaign/campaignActions';
import { resetReportData } from '../../redux/reporting/reportingActions';
import { resetCreativeData } from '../../redux/creative/creativeActions';
import { resetWowData } from '../../redux/wow/wowActions';
import { SET_ISSKAN, SET_DOLLAR } from '../../redux/campaign/campaignTypes';
import { SET_CAMPAIGN_LIST_FOR_REPORTING, CLEAR_CAMPAIGN_LIST } from '../../redux/advertiser/advertiserTypes';
import { fetchUserDashboardPermissions } from '../../redux/user/userActions';
import CampaignAutocompleteDropDown from './CampaignAutocompleteDropDown';
import ApplyFilterPage from './ApplyFilterPage';
import ApplyJSTFilterPage from './ApplyJSTFilterPage';
import { setTimeZoneSettings } from '../../redux/user/userActions';
import { IconCurrencyYen, IconCurrencyDollar } from '@tabler/icons';
const SearchBarWow = ({
  campaign_list,
  advertiser_guid,
  isSkanPresent,
  sfId,
  fetchCampaignsForAdvertiser,
  fetchSkanCampaignsForAdvertiser,
  resetScreenData,
  resetReportData,
  resetCreativeData,
  timeZone,
  setTimeZoneSettings,
  isDollar,
  resetWowData,
  startDate,
  endDate
}) => {
  const theme = useTheme();
  const campaigns = campaign_list;
  const dispatch = useDispatch();
  const [showCalendar, setShowCalendar] = useState(false);
  const [selectionCount, setSelectionCount] = useState(0);
  const [isSkan, setIsSkan] = useState(isSkanPresent);
  const handleSwitch = (e) => {
    setChecked(e.target.checked);
  };
  const [selectedCampaigns, setSelectedCampaigns] = useState([]);
  const [value, setValue] = React.useState([]);
  const [selectedCampaignsv1, setSelectedCampaignsv1] = React.useState([]);
  const [selectAll, setSelectAll] = React.useState(false);
  const [dollar, setDollar] = useState(isDollar);
  // Add state to track if we need to refetch
  const quarterRanges = useSelector((state) => state.wowReducer.wow_quarter_ranges);

  // ADD REFS for Debounce logic
  const abortControllerRef = useRef(null);
  const debounceTimerRef = useRef(null);

  // Helper to cancel previous request
  const cancelPreviousRequest = useCallback(() => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
      console.log('🚫 Cancelled previous campaign fetch while toggling');
    }
    abortControllerRef.current = new AbortController();
    return abortControllerRef.current.signal;
  }, []);

  // Debounced fetch function
  const debouncedFetchCampaigns = useCallback(
    (quarterRanges, isSkan) => {
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }

      const signal = cancelPreviousRequest();

      debounceTimerRef.current = setTimeout(() => {
        console.log('🔍 Debounced fetch: Fetching campaigns after toggle');

        dispatch(fetchCampaignsForQuarters(advertiser_guid, sfId, quarterRanges, isSkan, signal));
      }, 300);
    },
    [advertiser_guid, sfId, dispatch, cancelPreviousRequest]
  );

  useEffect(() => {
    console.log('🟢 SearchBarWow mounted on:', window.location.pathname);
  }, []);

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }
    };
  }, []);

  useEffect(() => {
    console.log('SearchBarWow - Dates:', {
      startDate,
      endDate,
      type: typeof startDate
    });
  }, [startDate, endDate]);
  useEffect(() => {
    console.log('SearchBarWow - Campaign List:', {
      count: campaign_list.length,
      campaigns: campaign_list.map((c) => c.campaign_name)
    });
  }, [campaign_list]);
  useEffect(() => {
    // console.log("advertiser_guid",advertiser_guid)
    setSelectedCampaigns([]);
  }, [advertiser_guid]);

  // UTC toggle
  const handleSkanCheck = (e) => {
    const checked = e.target.checked;
    setIsSkan(checked);
    dispatch({ type: SET_ISSKAN, payload: checked });

    // Cancel any in-flight requests
    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }

    // CLEAR CAMPAIGN LIST FIRST
    dispatch({ type: CLEAR_CAMPAIGN_LIST });

    // Reset old data
    resetScreenData();
    resetReportData();
    resetCreativeData();
    resetWowData();

    // REFETCH CAMPAIGNS with new platform
    if (advertiser_guid && sfId && quarterRanges && quarterRanges.length > 0) {
      console.log('🔄 Toggle: Refetching campaigns for new platform', {
        isSkan: checked,
        advertiser_guid,
        quarterRanges
      });
      debouncedFetchCampaigns(quarterRanges, checked);
      // dispatch(fetchCampaignsForQuarters(advertiser_guid, sfId, quarterRanges, checked));
    }
    // console.log('🔄 Toggle to', checked ? 'iOS' : 'Android');
  };

  // JST toggle
  const handleJPKRCheck = (e) => {
    const checked = e.target.checked;
    setIsSkan(checked);
    dispatch({ type: SET_ISSKAN, payload: checked });

    // Cancel any in-flight requests
    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }

    // CLEAR CAMPAIGN LIST FIRST
    dispatch({ type: CLEAR_CAMPAIGN_LIST });

    resetScreenData();
    resetReportData();
    resetCreativeData();
    resetWowData();

    // REFETCH CAMPAIGNS with new platform
    if (advertiser_guid && sfId && quarterRanges && quarterRanges.length > 0) {
      console.log('🔄 Toggle: Refetching campaigns for new platform', {
        isSkan: checked,
        advertiser_guid,
        quarterRanges
      });
      debouncedFetchCampaigns(quarterRanges, checked);
      // dispatch(fetchCampaignsForQuarters(advertiser_guid, sfId, quarterRanges, checked));
    }
    // console.log('🔄 Toggle to', checked ? 'SKAN' : 'Non-SKAN');
  };

  const handleCurrencyChange = (e) => {
    var flippedCurrency = !dollar;
    //console.log('flippedCurrency', flippedCurrency);
    setDollar(!dollar);
    dispatch({ type: SET_DOLLAR, payload: flippedCurrency });
  };

  useEffect(() => {
    setTimeZoneSettings(timeZone, isSkan);
    // Refetch user permissions when timezone or data type changes
    dispatch(fetchUserDashboardPermissions());
  }, [timeZone, isSkan]);

  return (
    <AppBar
      enableColorOnDark
      position="static"
      color="inherit"
      elevation={0}
      sx={{
        bgcolor: theme.palette.background.default
      }}
    >
      <Toolbar style={{ width: '100%' }}>
        <Grid container spacing={gridSpacing}>
          <Grid item lg={timeZone == 'JST' ? 5 : 6} md={12} sm={6} xs={12}>
            <CampaignAutocompleteDropDown />
          </Grid>
          <Grid item lg={3} md={6} sm={3} xs={6}>
            <WowQuarterDropDown />
          </Grid>
          <Grid item lg={1.5} md={6} sm={6} xs={6}>
            {timeZone == 'UTC' ? (
              <div className="skan-filter">
                <Typography variant="h5">Android</Typography>
                <Switch
                  name={name}
                  checked={isSkan}
                  value={isSkan}
                  onChange={handleSkanCheck}
                  inputProps={{ 'aria-label': 'switch' }}
                />{' '}
                <Typography variant="h5">iOS</Typography>
              </div>
            ) : (
              <div className="skan-filter">
                <Typography variant="h5">Non-SKAN</Typography>
                <Switch
                  name={name}
                  checked={isSkan}
                  value={isSkan}
                  onChange={handleJPKRCheck}
                  inputProps={{ 'aria-label': 'switch' }}
                />{' '}
                <Typography variant="h5">SKAN</Typography>
              </div>
            )}
          </Grid>
          {timeZone == 'JST' ? (
            <Grid item lg={1} md={6} sm={6} xs={6}>
              <div className="skan-filter">
                <Typography variant="h5">
                  <IconCurrencyYen stroke={1.7} size="1rem" />
                </Typography>
                <Switch
                  name={name}
                  checked={dollar}
                  value={dollar}
                  onChange={handleCurrencyChange}
                  inputProps={{ 'aria-label': 'switch' }}
                />{' '}
                <Typography variant="h5">
                  <IconCurrencyDollar stroke={1.7} size="1rem" />
                </Typography>
              </div>
            </Grid>
          ) : (
            ''
          )}

          <Grid item lg={1.5} md={2} sm={2} xs={6}>
            {timeZone == 'UTC' ? <ApplyFilterPage /> : <ApplyJSTFilterPage />}
          </Grid>
        </Grid>
      </Toolbar>
    </AppBar>
  );
};
const mapStateToProps = (state) => {
  return {
    loading: state.advertiserReducer.loading,
    campaign_list: state.advertiserReducer.campaign_list,
    advertiser_guid: state.advertiserReducer.advertiser_guid,
    sfId: state.advertiserReducer.sfId,
    isSkanPresent: state.campaignReducer.isSkan,
    isDollar: state.campaignReducer.isDollar,
    advertiser_campaign_fetching: state.advertiserReducer.advertiser_campaign_fetching,
    performanceLoading: state.campaignReducer.performanceLoading,
    widzardLoading: state.campaignReducer.widzardLoading,
    reportLoading: state.campaignReducer.reportLoading,
    timeZone: state.advertiserReducer.timeZone,
    startDate: state.wowReducer.wow_start_date, // WoW Start Date
    endDate: state.wowReducer.wow_end_date, // WoW End Date
    quarterRanges: state.wowReducer.wow_quarter_ranges
  };
};
const mapDispatchToProps = {
  setSelectedAdvertiser: setSelectedAdvertiser,
  fetchCampaignsByAdvertiserGuid: fetchCampaignsByAdvertiserGuid,
  fetchCampaignsForAdvertiser: fetchCampaignsForAdvertiser,
  fetchSkanCampaignsForAdvertiser: fetchSkanCampaignsForAdvertiser,
  resetScreenData: resetScreenData,
  resetReportData: resetReportData,
  resetCreativeData: resetCreativeData,
  setTimeZoneSettings: setTimeZoneSettings,
  resetWowData: resetWowData,
  fetchCampaignsForQuarters: fetchCampaignsForQuarters
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchBarWow);
